import { injectIntl } from 'react-intl';
import ProductFormPhoneInput from './ProductFormPhoneInput';

export default injectIntl(ProductFormPhoneInput);
